// src/hooks/useAddAIGeneratedWatermark.js
import { useCallback } from "react";

export const useAddAIGeneratedWatermark = () => {
  const addAIGeneratedWatermark = useCallback((dataUrl) => {
    return new Promise((resolve) => {
      if (!dataUrl) return resolve(dataUrl);

      const img = new Image();
      img.onload = () => {
        try {
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;

          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);

          // 기준 1080px에서 24px / 44px을 비율로 스케일
          const baseFontSize = 24;
          const baseMargin = 44;
          const scale = canvas.width / 1080; // 템플릿이 1080 기준이면 OK

          const fontSize = baseFontSize * scale;
          const margin = baseMargin * scale;

          ctx.font = `${fontSize}px Pretendard, -apple-system, BlinkMacSystemFont, system-ui, sans-serif`;
          ctx.fillStyle = "#FFFFFF";
          ctx.textBaseline = "bottom";
          ctx.textAlign = "right";

          // 가독성을 위해 약간의 그림자
          ctx.shadowColor = "rgba(0,0,0,0.35)";
          ctx.shadowBlur = 2;
          ctx.shadowOffsetX = 0;
          ctx.shadowOffsetY = 0;

          const text = "Wizmarket AI";
          const x = canvas.width - margin;  // 오른쪽에서 44px
          const y = canvas.height - margin; // 아래에서 44px

          ctx.fillText(text, x, y);

          const result = canvas.toDataURL("image/jpeg", 0.9);
          resolve(result);
        } catch (e) {
          console.error("워터마크 추가 중 오류:", e);
          resolve(dataUrl); // 문제 생기면 원본 그대로 반환
        }
      };
      img.onerror = (e) => {
        console.error("워터마크용 이미지 로드 실패:", e);
        resolve(dataUrl);
      };

      img.src = dataUrl;
    });
  }, []);

  return addAIGeneratedWatermark;
};
